import React from 'react';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import EmailIcon from '@mui/icons-material/Email';

function Contact() {
  return (
    <div>
      <div className="my-2 ml-2">
        <div className="text-lg font-light mt-5 selection:flex items-center justify-between">
          <div>ติดต่อเรา</div>
          <div />
        </div>
      </div>
      <div className="flex">
        <div className="w-full px-2 py-4">
          <div className="px-6 py-6 bg-white rounded-lg border border-gray-200 shadow-md ">
            <div><PhoneInTalkIcon fontSize="large" /> 022577000 - CallCenter </div>
            <div className="ml-11">022577111 - NOC</div>
            <br />
            <div><EmailIcon fontSize="large" /> E-mail : xxxxxxx@gmail.com</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
